export enum TaskType {
	None = 'None',
	Audit = 'Audit',
	Document = 'Document',
	OnlineTraining = 'OnlineTraining',
	OfflineTraining = 'OfflineTraining',
	Video = 'Video',
}
